import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, strictAdmin = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#F8FAFC]">
        <div className="text-[#475569]">Loading...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password && window.location.pathname !== "/force-change-password") {
    return <Navigate to="/force-change-password" replace />;
  }
  if (adminOnly && user.role === "student") return <Navigate to="/" replace />;
  if (strictAdmin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}
